
<template>
  <div class="address-container">
    <a
      v-if="address"
      :href="`http://www.google.com/maps/place/${destinationLatitude},${destinationLongitude}`"
      target="_blank"
      class="d-flex white--text display-14"
    >
      <v-icon
        right
        dark
        color="white"
        :class="'icon-forma-1-copy-12 v-align-top'"
      />
      <span class="v-align-top">{{ address }}</span>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    destinationLatitude: {
      type: Number,
    },
    destinationLongitude: {
      type: Number,
    },
    address: {
      type: String,
    },
  },
};
</script>
<style lang="scss" scoped>
.address-container {
  background-color: #3e4a54;
  opacity: 0.8;
  padding: 10px;
  width: 250px;
  border-radius: 10px;
  position: absolute;
  bottom: 35px;
  right: 30px;
  color: white;
}
</style>
